import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid2,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import Header from "../../components/Header";
import { Formik, useFormik } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as yup from "yup";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useMemo, useState } from "react";
import NotificationToaste from "../global/NotificationToaste";
import {
  AccessAlarm,
  Add,
  Delete,
  DeleteForever,
  EmailRounded,
  PictureAsPdf,
  PrecisionManufacturing,
  SaveAs,
  Summarize,
} from "@mui/icons-material";
import { tokens } from "../../theme";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const top100Films = [
  { label: "PRDA-Anuradhapura", year: 1994 },
  { label: "Irrigation DPT", year: 1972 },
  { label: "ABC Consructions", year: 1974 },
];

const jobTypes = [
  { label: "Concrete Works", year: 1994 },
  { label: "Aluminium Works", year: 1972 },
  { label: "Brick Works", year: 1974 },
];

const NewJob = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [data, setData] = useState([]);
  const [systemId, setSystemId] = useState("--AUTO--");
  const [type, setType] = useState([{ type: "Institute" }, { type: "Client" }]);
  const [testsDataArray, setTestDataArray] = useState([]);
  const [testData, setTestData] = useState({
    testType: "",
    quantity: "",
    jobPrice: "",
    collectMethod: "",
    reportCollectMethod: "",
    total: "",
  });
  const initialValues = {
    regDate: "",
    institute: "",
    client: "",
    project: "",
    contactPerson: "",
    contactNo: "",
    emai: "",
    status: false,
  };

  useEffect(() => {
    // loadAllRequests();
  }, []);

  const loadAllRequests = async () => {
    const result = await axios.get(`http://localhost:8080/api/v1/labreq`);
    setData(result.data);
  };

  const handleFormSubmit = async (values) => {
    console.log(values);

    await axios
      .post("http://localhost:8080/api/v1/labreq", values)
      .then(function (response) {
        console.log(response);
        setMessage("New request saved successfully..!");
        setMessageType("success");
        setOpen(true);
        loadAllRequests();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  let navigate = useNavigate();

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: "jobNo", //access nested data with dot notation
        header: "Job No",
        size: 10,
      },
      {
        accessorKey: "jobName",
        header: "Job Name",
        size: 200,
      },
      {
        accessorKey: "regDate", //normal accessorKey
        header: "Date",
        size: 80,
      },
      {
        accessorKey: "institute",
        header: "Institute",
        size: 100,
      },
      {
        accessorKey: "jobType",
        header: "Job Type",
        size: 100,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows
      sx: {},
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          console.info("View Profile", row);
          closeMenu();
        }}
      >
        <AccessAlarm /> &nbsp; View Profile
      </MenuItem>,
      <MenuItem
        key={2}
        onClick={() => {
          console.info("Remove", row);
          closeMenu();
        }}
      >
        <Delete /> &nbsp; Remove
      </MenuItem>,
      <MenuItem
        key={3}
        onClick={() => {
          console.info("Share", row);
          closeMenu();
        }}
      >
        <PrecisionManufacturing /> &nbsp; Share
      </MenuItem>,
    ],
  });

  const AddComponentTest = (indexToDelete) => {
    return (
      <Box
        display="grid"
        gap="8px"
        width="100%"
        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
        sx={{
          margin: "3px 0px 3px 0px",
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 8",
          },
        }}
      >
        <Autocomplete
          sx={{
            gridColumn: "span 6",
            margin: "0px",
            padding: "0px",
            alignContent: "flex-end",
          }}
          name="type"
          onInputChange={(e, newVal, reason) => {
            if (reason === "reset") {
              console.log("reset");
            } else {
              console.log("not reset");
            }
          }}
          renderInput={(params) => (
            <TextField
              name="type"
              sx={{ margin: "0px", padding: "0px" }}
              {...params}
              size="small"
              label="Test Type"
            />
          )}
        />

        <TextField
          variant="outlined"
          type="text"
          label="Quantity"
          size="small"
          name="ins_code"
          sx={{
            gridColumn: "span 2",
          }}
        />
        <TextField
          variant="outlined"
          type="text"
          label="Job Price"
          size="small"
          name="ins_code"
          sx={{
            gridColumn: "span 2",
          }}
        />

        <TextField
          variant="outlined"
          type="text"
          label="Total"
          size="small"
          name="ins_code"
          sx={{
            gridColumn: "span 2",
          }}
        />
        <Autocomplete
          sx={{
            gridColumn: "span 2",
            margin: "0px",
            padding: "0px",
            alignContent: "flex-end",
          }}
          name="type"
          onInputChange={(e, newVal, reason) => {
            if (reason === "reset") {
              console.log("reset");
            } else {
              console.log("not reset");
            }
          }}
          renderInput={(params) => (
            <TextField
              name="type"
              sx={{ margin: "0px", padding: "0px" }}
              {...params}
              size="small"
              label="Sample colletc method"
            />
          )}
        />
        <Autocomplete
          sx={{
            gridColumn: "span 2",
            margin: "0px",
            padding: "0px",
            alignContent: "flex-end",
          }}
          name="type"
          onInputChange={(e, newVal, reason) => {
            if (reason === "reset") {
              console.log("reset");
            } else {
              console.log("not reset");
            }
          }}
          renderInput={(params) => (
            <TextField
              name="type"
              sx={{ margin: "0px", padding: "0px" }}
              {...params}
              size="small"
              label="Report colletc method"
            />
          )}
        />
      </Box>
    );
  };

  const TableData = () => {
    return (
      <Card
        variant="outlined"
        sx={{
          border: `${colors.greenAccent[500]} solid thin`,
          width: "100%",
          marginBottom: "6px",
          //   backgroundColor: colors.grey[900],
        }}
      >
        <CardContent style={{ paddingBottom: "2px" }}>
          <Box
            display="grid"
            gap="8px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 5",
              },
            }}
          >
            <Box
              sx={{
                gridColumn: "span 5",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography variant="h5" color={colors.blueAccent[500]}>
                  Clay brick test Clay brick test Clay brick test Clay brick
                  test Clay brick test
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                gridColumn: "span 1",
              }}
            >
              <Typography variant="h5">Report Collect Method</Typography>
              <Typography variant="h5" color="success">
                Email
              </Typography>
            </Box>
            <Box
              sx={{
                gridColumn: "span 1",
              }}
            >
              <Typography variant="h5">Sample Collect Method</Typography>
              <Typography variant="h5" color="success">
                Delivered to lab
              </Typography>
            </Box>
            <Box
              sx={{
                gridColumn: "span 1",
              }}
            >
              <Typography variant="h5">Price (Rs)</Typography>
              <Typography variant="h5" color="success">
                2,500.00
              </Typography>
            </Box>
            <Box
              sx={{
                gridColumn: "span 1",
              }}
            >
              <Typography variant="h5">Quantity</Typography>
              <Typography variant="h5" color="success">
                2 Nos
              </Typography>
            </Box>
            <Box
              sx={{
                gridColumn: "span 1",
              }}
            >
              <Typography variant="h3" color="success" fontWeight={550}>
                Rs 3600.00
              </Typography>
            </Box>
          </Box>
        </CardContent>
        <Divider />
        <CardActions
          sx={{
            margin: 0,
            paddingTop: "0px",
            paddingBottom: "0px",
            justifyContent: "space-between",
          }}
        >
          <Box display="flex" alignItems="center">
            <Typography variant="h5" color="error">
              Job No : 2025/02
            </Typography>
            <IconButton aria-label="add an alarm">
              <PictureAsPdf color="info" sx={{ fontSize: "25px" }} />
            </IconButton>
            <IconButton aria-label="add an alarm">
              <EmailRounded color="info" sx={{ fontSize: "25px" }} />
            </IconButton>
          </Box>
          <Box>
            <IconButton color="info" aria-label="add an alarm">
              <SaveAs sx={{ fontSize: "25px" }} />
            </IconButton>
            <IconButton color="error" aria-label="add an alarm">
              <DeleteForever sx={{ fontSize: "25px" }} />
            </IconButton>
          </Box>
        </CardActions>
      </Card>
    );
  };

  useEffect(() => {}, [testsDataArray]);

  const handleAddTest = () => {
    setTestDataArray((pre) => [...pre, {}]);
    console.log(testsDataArray);
  };

  const deleteSelected = (indexToDelete) => {
    setTestDataArray(testsDataArray.filter((data) => data.id !== data.id));
  };

  const [openModal, setOpenModal] = useState(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    handleAddTest();
  };

  const AddDataModal = () => {
    return (
      <Dialog
        open={openModal}
        maxWidth="lg"
        // onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Header title="Add / Update" subtitle="Lab tests data" />
        </DialogTitle>
        <Divider />
        <DialogContent>
          <AddComponentTest />
        </DialogContent>
        <Divider />
        <DialogActions sx={{ paddingRight: "25px" }}>
          <Button
            variant="contained"
            color="secondary"
            autoFocus
            onClick={handleCloseModal}
            startIcon={<SaveAs />}
            size="medium"
          >
            SAVE DATA
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    onSubmit: handleFormSubmit,
    initialValues: initialValues,
    validationSchema: checkoutSchema,
    enableReinitialize: true,
  });

  const [institutes, setInstitutes] = useState([]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{ padding: "15px", borderRadius: "8px", width: "70%" }}
        elevation={3}
      >
        <Header title="New Job Request" subtitle="Create new requests" />

        <form onSubmit={handleSubmit}>
          <Box
            display="grid"
            gap="3px"
            rowGap="10px"
            border="red solid thin"
            gridTemplateColumns="repeat(6, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 6",
              },
            }}
          >
            <Box
              sx={{
                gridColumn: "span 1",
                textAlign: "center",
                alignContent: "center",
                border: "red solid thin",
              }}
            >
              <Typography
                alignContent="center"
                color={colors.redAccent[500]}
                variant="h5"
              >
                ID {systemId}
              </Typography>
            </Box>
            <Box
              sx={{
                gridColumn: "span 1",
                alignContent: "center",
                border: "red solid thin",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  sx={{
                    gridColumn: "span 1",
                    width: "100%",
                  }}
                  components={["DatePicker"]}
                >
                  <DatePicker
                    label="Register Date"
                    sx={{ width: "100%" }}
                    onChange={(e) => {
                      values.regDate = e === null ? "" : e;
                      console.log(initialValues.regDate);
                    }}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        values: "",
                        size: "small",
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box
              sx={{
                gridColumn: "span 1",
                alignContent: "center",
              }}
            >
              <TextField
                select
                label="Institute / Contractor"
                fullWidth
                size="small"
              >
                {institutes?.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <TextField
              variant="outlined"
              type="text"
              label="Project"
              size="small"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.ins_code}
              name="ins_code"
              error={!!touched.ins_code && !!errors.ins_code}
              helperText={touched.ins_code && errors.ins_code}
              sx={{
                gridColumn: "span 2",

                marginTop: "8px",
                input: { textAlign: "center" },
              }}
            />
            <TextField
              variant="outlined"
              type="text"
              label="Contact Person"
              size="small"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.ins_code}
              name="ins_code"
              error={!!touched.ins_code && !!errors.ins_code}
              helperText={touched.ins_code && errors.ins_code}
              sx={{
                gridColumn: "span 2",
              }}
            />
            <TextField
              variant="outlined"
              type="text"
              label="Contact No"
              size="small"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.ins_code}
              name="ins_code"
              error={!!touched.ins_code && !!errors.ins_code}
              helperText={touched.ins_code && errors.ins_code}
              sx={{
                gridColumn: "span 2",
              }}
            />
            <TextField
              variant="outlined"
              type="text"
              label="Email"
              size="small"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.ins_code}
              name="ins_code"
              error={!!touched.ins_code && !!errors.ins_code}
              helperText={touched.ins_code && errors.ins_code}
              sx={{
                gridColumn: "span 2",
              }}
            />
          </Box>
          <Divider sx={{ marginTop: "5px" }} />
          <Box
            sx={{ margin: "10px" }}
            display="flex"
            justifyContent="space-between"
            marginBottom="1px"
          >
            <Button
              type="button"
              startIcon={<Add />}
              color="secondary"
              variant="contained"
              onClick={handleClickOpenModal}
            >
              Add Test
            </Button>
            <Button
              type="submit"
              startIcon={<Summarize />}
              color="secondary"
              variant="contained"
            >
              Generate Request ID
            </Button>
          </Box>
          <Box
            sx={{ marginTop: "10px", width: "100%" }}
            display="flex"
            flexDirection="column"
            marginBottom="1px"
          >
            {testsDataArray.map((data, index, originalArray) => (
              <TableData key={index} index={index} />
            ))}
          </Box>
        </form>
        <Divider>
          <Chip label="TOTAL AMOUNT" size="medium" />
        </Divider>
        <Box
          display="flex"
          sx={{
            marginTop: "8px",
            justifyContent: "space-between",
          }}
        >
          <Box
            gap={1}
            display="grid"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 4",
              },
            }}
          >
            <TextField
              variant="outlined"
              type="text"
              label="Transport Distance (km)"
              size="small"
              name="ins_code"
              sx={{
                gridColumn: "span 2",
              }}
            />
            <Typography
              variant="h4"
              alignContent="center"
              sx={{
                gridColumn: "span 2",
                marginLeft: "5px",
              }}
              color={colors.grey[500]}
              fontWeight={550}
            >
              Rs 500.00
            </Typography>
          </Box>
          <Box>
            <Typography variant="h2" color="success" fontWeight={550}>
              Rs 5,500.00
            </Typography>
          </Box>
        </Box>
      </Paper>
      <AddDataModal />
      <Paper
        sx={{
          padding: "15px",
          borderRadius: "8px",
          width: "70%",
          marginTop: "15px",
        }}
        elevation={3}
      >
        <Header title="All requests" subtitle="Update / Delete Requests" />
        <MaterialReactTable table={table} />
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  regDate: yup.string().required("Register date is required"),
  jobName: yup.string().required("Job name is required"),
  institute: yup.string().required("Institute / Contractor is required"),
  email: yup.string().email("invalid email").required("Email is required"),
  // jobType: yup.string().required("Job type is required"),
  // note: yup.string().required("required"),
});

export default NewJob;
